// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__svhfs","body":"styles_body__ksWRv"};